import { createReducer, on } from "@ngrx/store";
import { StatusIntegracao } from "@shared/models/status-integracao/status-integracao.model";
import { updateStatusIntegracoes } from "../actions/statusIntegracoes.action";

export const initialState: StatusIntegracao[] | undefined = undefined;

export const statusIntegracoesReducer = createReducer(
    initialState,
    on(updateStatusIntegracoes, (previousState, newStatusIntegracoes) => newStatusIntegracoes.statusIntegracoes),
)